// extracted by mini-css-extract-plugin
export var divider = "_do-7";
export var itemsToggle = "_do-8";
export var mergeModal = "_do-1";
export var optionCard = "_do-4";
export var radioGroup = "_do-6";
export var radioOption = "_do-0";
export var selected = "_do-5";
export var shipmentOptions = "_do-2";
export var tableOptions = "_do-3";